<template>
  <div class="content-v2">
    <BreadcrumbV2 :items="breadcrumbItems" />
    <div class="detail-img-full">
      <img :src="staff.image" :alt="staff.title" />
    </div>
    <div class="detail-text-v2">
      <h2>{{ staff.title }}</h2>
      <p class="date">{{ staff.date }}</p>
      <div v-html="staff.desc"></div>
    </div>
  </div>
</template>

<script>
import BreadcrumbV2 from '@/components/BreadcrumbV2.vue'
import { getCultureArticleDetail } from '@/api/portal'
import { resolveFileUrl } from '@/utils/request'
import defaultStaffImage from '@/assets/images/staff2.svg'

export default {
  name: 'StaffDetailV2',
  components: { BreadcrumbV2 },
  data() {
    return {
      breadcrumbItems: [
        { nameKey: 'common.enterprise', path: '/enterprise' },
        { nameKey: 'common.staff', path: '/enterprise/staff' }
      ],
      staff: {
        title: '社会活动照片',
        date: '拍摄时间：2025-10-15',
        image: defaultStaffImage,
        desc: '公司组织员工团建活动，增强团队凝聚力。活动中大家积极参与，展现了盛博莱电力员工积极向上的精神风貌。'
      }
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(id) {
        this.staff.title = '社会活动照片 ' + id
        this.loadDetail()
      }
    }
  },
  methods: {
    loadDetail() {
      const id = this.$route.params.id
      if (!id) {
        return
      }
      getCultureArticleDetail(id).then(data => {
        if (!data || !data.articleId) {
          return
        }
        this.staff = {
          title: data.articleTitle,
          date: data.publishDate ? `拍摄时间：${data.publishDate}` : '',
          image: resolveFileUrl(data.coverUrl, defaultStaffImage),
          desc: data.articleContent || data.summary || ''
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-img-full {
  border-radius: 24px;
  overflow: hidden;
  margin-bottom: 40px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.08);

  img {
    width: 100%;
    max-height: 500px;
    object-fit: contain;
    display: block;
  }
}

.detail-text-v2 {
  h2 {
    font-size: 28px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 12px;
  }

  .date {
    font-size: 15px;
    color: #94a3b8;
    margin-bottom: 20px;
  }

  p,
  ::v-deep p {
    font-size: 17px;
    line-height: 2;
    color: #475569;
    text-indent: 2em;
  }
}
</style>
